import React, {useEffect, useRef, useState} from 'react';
import './PlaceAutocomplete.less';
import debounce from 'lodash/debounce';
import Config from "../../../config";

const scriptElementId = 'places-script';
let autocompleteService = null;
let getPlacePredictionsDebounced = debounce((query, sessionToken, callback) => {
	autocompleteService && autocompleteService.getPlacePredictions({
		input: query,
		types: ['address'],
		sessionToken
	}, callback);
}, 600);


export const PlaceAutocomplete = ({query, sessionToken, children}) => {
	const [predictions, setPredictions] = useState([]);
	const [predictionsQuery, setPredictionsQuery] = useState('');

	//TODO use sessiontoken for lower pricing
	useEffect(() => {
		if (!document.getElementById(scriptElementId)) {
			const script = document.createElement('script');
			script.id = scriptElementId;
			script.type = 'text/javascript';
			script.src = `https://maps.googleapis.com/maps/api/js?key=${Config.googleMapsApiKey}&libraries=places`;

			document.body.appendChild(script);
		}
	}, []);

	useEffect(() => {
		if (!(window.google && window.google.maps && window.google.maps.places)) return;

		if (!!autocompleteService) return;

		autocompleteService = new google.maps.places.AutocompleteService()
	});

	useEffect(() => {
		if (predictionsQuery === query) return;


		if (!(query && query.length > 1)) {
			setPredictions([]);
			setPredictionsQuery(query);
			return;
		}

		getPlacePredictionsDebounced(query, sessionToken, (predictions, status) => {
			console.log('+-+ predictions received:');
			console.log(status);
			setPredictions(predictions?.filter(prediction => prediction.types.includes('street_address') || prediction.types.includes('premise')));
			setPredictionsQuery(query);
		});


	});


	return children(predictions || []);
}
